/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PlanTeamsEntryPointEntrypointProps } from './PlanTeamsEntryPoint.entrypoint.types.tsx';

type PlanTeamsEntryPointComponent = EntryPointComponent<
	{},
	{},
	PlanTeamsEntryPointEntrypointProps,
	{}
>;

export const planTeamsEntryPoint: EntryPoint<PlanTeamsEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction<PlanTeamsEntryPointComponent>(
		/* webpackChunkName: "async-plan-team-entrypoint" */ './PlanTeamsEntryPointRoot.tsx',
	),
	getPreloadProps: () => ({}),
});
